import styled, { css } from 'styled-components';
import { px2rem, mq } from '../../../../stylesheets/tools';
import { fontFamilies } from '../../../../stylesheets/settings';

const categoryColors = {
  ressources: {
    default: '#9770C8',
    dark: '#64389A'
  },
  agriculture: {
    default: '#A6DD89',
    dark: '#6AA349'
  },
  work: {
    default: '#E26372',
    dark: '#B04B57'
  },
  energy: {
    default: '#AD7496',
    dark: '#92577A'
  },
  nutrition: {
    default: '#45A88F',
    dark: '#308D76'
  },
  health: {
    default: '#EE9E77',
    dark: '#EA7137'
  },
  mobility: {
    default: '#F3C85E',
    dark: '#D39908'
  },
  city: {
    default: '#117D94',
    dark: '#0D6477'
  },
  democracy: {
    default: '#D1578D',
    dark: '#8E3B60'
  }
};

const StyledEducationCategoryCard = styled.div`
  width: 100%;
  position: relative;
  margin: ${px2rem('20px')} 0;

  ${mq('l')} {
    max-width: 180px;
    margin: 0 -20px;
    z-index: ${props => props.index && 10 - props.index};
  }

  .category-card {
    border-radius: 4px;
    filter: drop-shadow(4px 0px 2px rgba(0, 0, 0, 0.2));

    ${({ category }) =>
      category &&
      css`
        background: ${categoryColors[category]?.default || 'inherit'};
        box-shadow: 2px -2px 0 2px ${categoryColors[category]?.dark || 'inherit'};
      `};
    ${mq('l')} {
      ${({ category }) =>
        category &&
        css`
          box-shadow: 3px -3px 0 3px ${categoryColors[category]?.dark || 'inherit'};
        `};
    }

    ${mq('l')} {
      border-radius: 6px;
      filter: drop-shadow(14px -4px 6px rgba(0, 0, 0, 0.15));
      transition: all 0.25s;
      transition-timing-function: cubic-bezier(0, 0, 0.58, 1);

      ${props =>
        props.isFilterActive
          ? css`
              transform: skew(0, 24deg) translateY(-80px);
            `
          : css`
              transform: skew(0, 24deg);
            `}
      &:hover {
        transform: skew(0, 24deg) translateY(-80px);
      }
    }

    .category-card__content {
      border-radius: 4px;
      background: white;
      padding: ${px2rem('30px')} ${px2rem('10px')};
      display: flex;
      flex-direction: column;
      gap: ${px2rem('15px')};
      align-items: center;

      ${mq('l')} {
        border-radius: 6px;
        padding: ${px2rem('30px')} ${px2rem('15px')};
      }
      .category-card__icon {
        ${({ category }) =>
          category &&
          css`
            color: ${categoryColors[category]?.default || 'inherit'};
          `};
        height: ${px2rem('80px')};
        width: ${px2rem('80px')};

        ${mq('l')} {
          height: ${px2rem('100px')};
          width: ${px2rem('100px')};
        }
      }

      .category-card__title {
        font-family: ${fontFamilies.default};
        font-size: ${px2rem('14px')};
        white-space: nowrap;
        color: black;

        ${mq('l')} {
          font-size: ${px2rem('18px')};
        }

        ${mq('xl')} {
          font-size: ${px2rem('20px')};
        }
      }
    }

    .category-card__dots {
      padding: ${px2rem('16px')};

      .category-card__dots-container {
        position: relative;
        height: ${px2rem('36px')};
        width: 100%;
      }
    }
  }
  .category-card__stretched-link {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .category-card__filter {
    transform: translateY(20px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${px2rem('10px')};

    ${mq('l')} {
      gap: ${px2rem('15px')};
      transform: translateY(40px);
    }

    .category-card__filter-icon {
      color: white;
      background: black;
      border-radius: 50%;
      height: ${px2rem('38px')};
      width: ${px2rem('38px')};
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .category-card__filter-title {
      font-family: ${fontFamilies.default};
      font-size: ${px2rem('16px')};
      color: black;

      ${mq('l')} {
        font-size: ${px2rem('24px')};
      }
    }
  }
`;

export default StyledEducationCategoryCard;
